import { queryStringParamsCache } from '../../app-kit/helpers/getCacheQueryStringParamsFromUrl';
import { SearchPageView } from '../../types';

export const getSearchPageViewFromURL = (url: string): SearchPageView => {
  const { view } = queryStringParamsCache.extractQueryAsParamsFromUrl(url);
  switch (view) {
    case 'map':
      return 'map';
    case 'list':
      return 'list';
    case 'map-list':
      return 'map-list';
    default:
      return 'map-list';
  }
};
